import { validateCriteriaConfiguration } from '../../../components/Criteria/CriteriaPanel/validation';
import { TEMPLATE_DEFAULTS } from './sequenceModel';

/* eslint-disable @typescript-eslint/no-explicit-any -- form values mirror the API */
/**
 * The classic editor's rules, limited to fields this editor shows. final-form counts every error the
 * validator returns, rendered or not, so a rule for a hidden field (return visits while returning
 * users are not targeted) would block publishing with nothing on screen to fix.
 */
export default function validate(values: Record<string, any>) {
  const errors: Record<string, any> = {};
  if (!values.sequenceName?.trim()) errors.sequenceName = 'Add a sequence name.';
  if (!values.site || typeof values.site !== 'object') errors.site = 'Pick a site.';
  if (!values.flex || Number(values.flex) < 1) errors.flex = 'Flex must be at least 1.';
  if (!values.priority || Number(values.priority) < 1) errors.priority = 'Priority must be at least 1.';
  if (values.targetReturningUsers && (!values.returnVisits || Number(values.returnVisits) < 1)) {
    errors.returnVisits = 'Return visits must be at least 1.';
  }
  TEMPLATE_DEFAULTS.forEach(({ layoutField, containerField }) => {
    if (!values[layoutField] || typeof values[layoutField] !== 'object') errors[layoutField] = 'Pick a default layout.';
    if (!values[containerField] || typeof values[containerField] !== 'object')
      errors[containerField] = 'Pick a default container.';
  });
  if (Array.isArray(values.customVariables)) {
    const variableErrors = values.customVariables.map((variable: any) =>
      !variable?.key || variable.key === 'SUD_' ? { key: 'Enter a key.' } : undefined
    );
    if (variableErrors.some(Boolean)) errors.customVariables = variableErrors;
  }
  const criteriaConfiguration = values?.criteria?.criteriaConfiguration;
  if (criteriaConfiguration) {
    const result = validateCriteriaConfiguration(criteriaConfiguration);
    if (result.hasErrors) errors.criteria = result.summary || 'The criteria have errors.';
  }
  return errors;
}

/** Which settings section each field lives in, so a section can say it needs attention. */
export const SECTION_FIELDS = {
  general: ['sequenceName', 'site', 'flex', 'priority', 'returnVisits'],
  templates: TEMPLATE_DEFAULTS.flatMap(({ layoutField, containerField }) => [layoutField, containerField]),
  customVariables: ['customVariables'],
};
